import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { addZero, useUpdatePeriod } from '../../utils/utils';

export default function DateTime({ initial = null, tz = 'Europe/Moscow' }) {
  const currentDate = new Date();
  const initialDate = initial ? new Date(initial) : currentDate;
  const [date, setDate] = useState(moment(initialDate).tz(tz).format('DD.MM.YYYY'));
  const [time, setTime] = useState(initialDate);
  const calculate = () => {
    const newTime = new Date(new Date().getTime() + window.serverTimeOffset);
    setTime(newTime);
    setDate(moment(newTime).tz(tz).format('DD.MM.YYYY'));
  };

  const [setPeriod] = useUpdatePeriod(calculate, 0.015, true);
  useEffect(() => setPeriod(0.015), []);

  if (!initial) {
    return null;
  }

  const timeText = moment(time).tz(tz).format('HH:mm:ss:SSS');
  return (
    <div className="date-time-block">
      <div className="date-text">{date}</div>
      <div className="time-text">{timeText}</div>
    </div>
  );
}
